<template>  
  <button class="flex flex-center preview-play" @click="handleClick">
    <Icon path="media" :name="playing ? 'play' : 'pause'" />
  </button>
</template>

<script>
import Icon from '@/components/icon'
import { addEvent, removeEvent } from '@/utils/event'
export default {
  name: 'PreviewPlay',
  components: {
    Icon
  },
  props: {
    refName: {
      type: String,
      require: true,
      default: 'video'
    },
  },
  computed: {
    playing: {
      get(){
        return this.$store.getters.playing
      },
      set(status) {
        this.$store.commit('UPDATE_PLAYING_STATUS', status)
      }
    },
    el() {
      return this.$parent.$refs[this.refName]
    },
  },
  mounted() {
    addEvent(this.el, 'pause', this.handlePause)
    addEvent(this.el, 'playing', this.handlePlaying)
  },
  beforeDestroy() {
    removeEvent(this.el, 'pause', this.handlePause)
    removeEvent(this.el, 'playing', this.handlePlaying)
  },
  methods: {
    handleClick() {
      this.handleChangeState(!this.playing)
    },
    handlePause() {
      this.handleChangeState(false)
    },
    handlePlaying() {
      this.handleChangeState(true)
    },
    handleChangeState(playing = false) {
      this.playing = playing
      this.$emit('change', playing)

      playing ? this.el.play() : this.el.pause()
    },
  }
}
</script>

<style lang="less">
  @import url('~@/styles/var.less');

  .preview-play {
    width: 46px;
    height: 40px;
    font-size: 20px;
    border-radius: 13px;
    background-color: rgba(146, 159, 183, 0.5);
  }
</style>